import { Differentiation } from 'approot/shared/differentiation/differentiation.constants';

export function getDifferentiationHeading(
  differentiation: Differentiation,
  unitQuizLabel: string
) {
  switch (differentiation) {
    case Differentiation.GreenCircle:
      return 'Core';
    case Differentiation.BlueSquare:
      return 'Deeper Learning';
    case Differentiation.BlackDiamond:
      return 'Challenging';
    case Differentiation.SelfAssessment:
      return 'Self-Assessment';
    case Differentiation.AnchorMap:
      return 'Anchor Map';
    case Differentiation.OrangeCross:
      return 'Support';
    case Differentiation.UnitQuiz:
      return unitQuizLabel;
  }
}

export function getDifferentiationDescriptionLesson(
  differentiation: Differentiation
): {
  title: string;
  description: string;
} {
  if (differentiation === Differentiation.GreenCircle) {
    return {
      title: 'Core Activity',
      description:
        'Central to the focus question or learning intention and includes surface, deeper and transfer of learning.',
    };
  } else if (differentiation === Differentiation.BlueSquare) {
    return {
      title: 'Deeper Learning Activity',
      description:
        'Takes thinking to the next level and requires more time, effort and sometimes research.',
    };
  } else if (differentiation === Differentiation.OrangeCross) {
    return {
      title: 'Support Activity',
      description:
        'Supports students who need more help to access and understand the core learning.',
    };
  } else {
    return {
      title: 'Challenging Activity',
      description: 'Requires extended critical and creative thinking.',
    };
  }
}

export function getDifferentiationDescriptionAssessment({
  differentiation,
  unitQuizLabel,
  unitQuizDescription,
}: {
  differentiation: Differentiation;
  unitQuizLabel: string;
  unitQuizDescription: string;
}): {
  title: string;
  description: string;
} {
  switch (differentiation) {
    case Differentiation.GreenCircle:
      return {
        title: 'Core Assessment Activity',
        description:
          'Central to the focus question or learning intention and include surface, deeper and transfer of learning.',
      };
    case Differentiation.BlueSquare:
      return {
        title: 'Deeper Learning Assessment Activity',
        description:
          'Takes thinking to the next level and require more time, effort and sometimes research.',
      };
    case Differentiation.BlackDiamond:
      return {
        title: 'Challenging Assessment Activity',
        description: 'Requires extended critical and creative thinking.',
      };
    case Differentiation.OrangeCross:
      return {
        title: 'Support or Extension',
        description:
          'Supports students who need more help to access and understand the core learning.',
      };
    case Differentiation.SelfAssessment:
      return {
        title: 'Self-Assessment',
        description: 'Supports students to reflect on their achievements.',
      };
    case Differentiation.AnchorMap:
      return {
        title: 'Anchor Map',
        description:
          'An Anchor Map is a frame for students to express and share their learning across a topic, unit of work or cycle of learning.',
      };
    case Differentiation.UnitQuiz:
      return {
        title: unitQuizLabel,
        description: unitQuizDescription,
      };
  }
}
